import { useRegisterSW } from 'virtual:pwa-register/react'

export function usePWAUpdate() {
    const {
        needRefresh: [needRefresh, setNeedRefresh],
        offlineReady: [offlineReady, setOfflineReady],
        updateServiceWorker,
    } = useRegisterSW({
        onRegisteredSW(_swUrl, registration) {
            if (!registration) return
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') {
                    registration.update().catch(() => {})
                }
            })
        },
        onRegisterError(error) {
            console.error('SW registration error:', error)
        },
    })

    function close() {
        setOfflineReady(false)
        setNeedRefresh(false)
    }

    return {
        needRefresh,
        offlineReady,
        updateSW: () => updateServiceWorker(),
        close,
    }
}
